import State from './State.js';
import Deck from './Deck.js';

export default class StateShuffle extends State {
    constructor(context) {
        super(context);  //this.context = type of 'Cribbage'
        this.name = 'shuffle';
    }
    setup() {
        this.isShuffled = false;
        //shuffle
        var deck = new Deck();
        deck.shuffle(this.context.cards);
        for (var i = 0; i < this.context.cards.length; i++) {
            let card = this.context.cards[i];
            card.pile = "cut"
            card.pilez = i;
            card.showfront = true;
        }

        this.context.playerTurn = this.context.dealer;
        this.context.sendEvent("cardMoved");

        this.createMessage();
    }
    action(command, value, player) {
        switch (command) {
            case "play": return this.shuffle(value, player); break;
            case "endCut": return this.endCut(player); break;
            default: this.unknownCommand(command, value, player);
        }
        this.createMessage();
    }
    getActions(player) {
        let actions = [];

        if (player === this.context.dealer) {
            if (!this.isShuffled) actions.push({ command: "play", value: null, player: player });
            if (this.isShuffled) actions.push({ command: "endCut" });
        }

        return actions;
    }
    createMessage() {

        let dealer = this.context.dealer;
        let messageDealer = "Select a card to shuffle the deck";

        if (dealer == "player1") {
            this.context.sendEvent("message", messageDealer, "player1");
            this.context.messagePlayer1 = messageDealer;
            this.context.messagePlayer2 = "";
        } else {
            this.context.sendEvent("message", messageDealer, "player2");
            this.context.messagePlayer1 = "";
            this.context.messagePlayer2 = messageDealer;
        }


    }
    shuffle(cardId, player) {

   
        if (player !== this.context.playerTurn) {
            this.invalidMove("It is not your turn.", player);
            return;
        }
        if (!player) {
            this.invalidMove("Not a valid player", player);
            return;
        }
        
        //shuffle
        var deck = new Deck();
        deck.shuffle(this.context.cards);
        for (var i = 0; i < this.context.cards.length; i++) {
            let card = this.context.cards[i];
            card.pile = "cut"
            card.pilez = i;
            card.showfront = true;
        }

        this.context.playerTurn = "";
        this.context.sendEvent("cardMoved");

        this.isShuffled = true;

         //call setup crib state
         this.context.setState("shuffleCut");

        return true;
    }
    endCut() {


        //call setup crib state
        this.context.setState("shuffleCut");

        return true;
    }

    //note: move invalidMove and unknownCommand to context? so no events are called from state?
    invalidMove(message, player) {
        this.context.sendEvent("invalidMove", message, player);
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}